const Theme = {
  logo_image_url: 'grandeferme.png',
  logo_height: 84,

  button_color: '#e36123',
  button_text_uppercase: true,
  button_radius: 4,

  text_font: `'Arial', sans-serif`,
  text_color: 'black',
  title_font: `'Arial', sans-serif`,
}

export default Theme
